/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useMemo, useState } from 'react'
import Topbar from '../../components/common/topbar/Topbar'
import { AttributeValueNewsan, AttributeValuesDTO, TableAction, TableDetailCell, TableHeaderCell } from '../../model/models-module'
import { addParam } from '../../utils/CommonUtils'
import {useData} from '../../components/hooks/useData'
import DataTable from '../../components/common/datatable/Datatable'
import { Box, Button, CircularProgress, FormControl, MenuItem, Modal, Select, Typography} from '@mui/material'
import classes from './AttributesValues.module.css'
import { GridDTO } from '../../model/dto-module'
import { useParams } from 'react-router-dom'
import EditIcon from '@mui/icons-material/Edit';
import NewsanIcons from '../../components/common/Icons'
import PopupSuccessError from '../../components/common/popup-success-error/PopupSuccessError'
import AxiosInterceptor from '../../services/http/AxiosInterceptor'
import axios from 'axios'
import ConfirmDialog from '../../components/common/confirm-dialog/ConfirmDialog'
import { CrudContainer } from './CrudContainer'
import { toast } from 'react-toastify'

class AttributesValuesGridDTO<T> extends GridDTO<T> {
  attributeData: any;
}

const AttributesValues = () => {
  const client = AxiosInterceptor.addInterceptor(process.env.REACT_APP_API_BASE_URL)
  const [errorResponse, setErrorResponse] = useState<string[] | null>(null);
  const {attributeStoreId, idAttributeRelation} = useParams<{attributeStoreId: string, idAttributeRelation: string}>();
  const [dataHeader, setDataHeader] = useState<TableHeaderCell[]>([]);
  const [dataTo, setDataTo] = useState<number>(50);
  const [countItems, setCountItems] = useState<number>(0);
  const [dataOffset, setDataOffset] = useState<number>(0);
  const [dataShow, setDataShow] = useState<TableDetailCell[]>([]);
  const [baseEndpoint, setBaseEndpoint] = useState<string>(`/attribute-values/byAttributeRelation/${idAttributeRelation}`);
  const [endpoint, setEndPoint] = useState<string>('');
  const [params] = useState<Map<string,string>>(new Map());
  const [loading, error, dataGrid] = useData<AttributesValuesGridDTO<AttributeValuesDTO>>(endpoint, 'GET', undefined);
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [loadingResponse, setLoadingResponse] = useState(false);
  const [showForm, setShowForm] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [newEditItem, setNewEditItem] = useState<AttributeValuesDTO>();
  const [endpointOptionGend, setEndpointOptionGend] = useState<string>(`attribute-values/gendByRelationsAttribute/${idAttributeRelation}/autocomplete?omit-configured=${isEdit}`);
  const [endpointOptionStore, setEndpointOptionStore] = useState<string>(`attribute-values/storeByRelationsAttribute/${attributeStoreId}/autocomplete`);
  const [loadingOptionsGend, errorOptionsGend, dataOptionsGend] = useData<AttributeValueNewsan[]>(endpointOptionGend, 'GET', undefined);
  const [loadingOptionsStore, errorOptionsStore, dataOptionsStore] = useData<AttributeValueNewsan[]>(endpointOptionStore, 'GET', undefined);
  const [selectedAttributeStore, setSelectedAttributeStore] = useState<AttributeValueNewsan>();
  const [selectedAttributeGEND, setSelectedAttributeGEND] = useState<AttributeValueNewsan>();
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [selectedRelationId, setSelectedRelationId] = useState<number | null>(null);
  const [idsSuggested, setIdsSuggesteds] = useState<number[]>([]);
  const [openIaModal, setOpenIaModal] = useState(false);
  const handleCloseIaModal = () => setOpenIaModal(false);

  useEffect(()=> {
    if (baseEndpoint === '') setBaseEndpoint(`/attribute-values/byAttributeRelation/${idAttributeRelation}`)
    if (endpointOptionGend === '') setEndpointOptionGend(`attribute-values/gendByRelationsAttribute/${idAttributeRelation}/autocomplete?omit-configured=${isEdit}`)
    if (endpointOptionStore === '') setEndpointOptionStore(`attribute-values/storeByRelationsAttribute/${attributeStoreId}/autocomplete`)
  }, [baseEndpoint, endpointOptionGend, endpointOptionStore])

  useEffect(()=> {
    addParam(dataTo, 'size', params, baseEndpoint, setEndPoint);
  }, [dataTo, baseEndpoint]);

  useEffect(()=> {
    addParam(dataOffset, 'page', params, baseEndpoint, setEndPoint);
  }, [dataOffset, baseEndpoint]);

  const handleDeleteClick = (relationId: number) => {
    setSelectedRelationId(relationId);
    setOpenConfirmDialog(true);
  };

  const confirmDelete = async () => {
    if (selectedRelationId !== null) {
      setShowPopup(true);
      await deleteAttributesValues(selectedRelationId);
      setOpenConfirmDialog(false);
      setSelectedRelationId(null);
    }
  };

	const deleteAttributesValues = async (relationId: number) => {
		try {
			setLoadingResponse(true);
			await client.delete(`/attribute-values/${relationId}`);
		} catch (error) {
			if (axios.isAxiosError(error)) {
				setErrorResponse(error.response?.data.message);
			} else if (error instanceof Error) {
				setErrorResponse([error.message]);
			} else {
				setErrorResponse(['Hubo un error en la solicitud']);
			}
		} finally {
			reloadTable()
      setLoadingResponse(false);
		}
	}

  useEffect(()=> {
    if(dataHeader.length === 0 ) {
      setDataHeader([
        new TableHeaderCell({label: 'Cod - Valor Tienda', key: 'codeStore', sorteable: false}),
        new TableHeaderCell({label: 'Cod - Valor GenD', key: 'codeNewsan', sorteable: false}),
      ])  
    }
  })

  useEffect(()=>{
    if(!loading && dataGrid) {
      setCountItems(dataGrid.count)
      let iaAssistance : number[] = [];
      setDataShow(dataGrid.results.map((r) => {
        if (r.relationsAttributesValues[0]?.suggestedAttributeValueNewsan?.id && !r.relationsAttributesValues[0]?.attributeValueNewsan){
          iaAssistance.push(r.relationsAttributesValues[0]?.id)
        }

        const actions: TableAction[] =  [
          new TableAction({label: 'Editar', action: () => {
            formatForm()
            setNewEditItem(r)
            setIsEdit(true)
            setShowForm(true)
          }, icon: <span className={classes.editIcon}><EditIcon></EditIcon></span>}),
        ]
        if (r.relationsAttributesValues[0]?.attributeValueNewsan?.id){
          actions.push(
            new TableAction({
              label: 'Eliminar',
              action: () => handleDeleteClick(r.relationsAttributesValues[0].id),
              icon: NewsanIcons.DELETE,
              enable: r.relationsAttributesValues.length > 0 
            }),
          )
        }
        return new TableDetailCell(
          {
            codeStore: `${r.code} - ${r.value}`,
            codeNewsan:
              r.relationsAttributesValues.length > 0 && r.relationsAttributesValues[0].attributeValueNewsan?.id
                ? `${r.relationsAttributesValues[0].attributeValueNewsan?.code} - ${r.relationsAttributesValues[0].attributeValueNewsan?.value}`
                : r.relationsAttributesValues[0]?.suggestedAttributeValueNewsan?.id ? 
                <div className={classes['iaContent']}>
                  <span>{r.relationsAttributesValues[0]?.suggestedAttributeValueNewsan?.code} - {r.relationsAttributesValues[0]?.suggestedAttributeValueNewsan?.value}</span>
                  <span className={classes['iaText']}>Recomendacion IA</span>
                  <div className={classes['iaButtonContent']}>
                    <Button className={classes['iaButton']} onClick={async () => {
                      if (r.relationsAttributesValues[0]?.suggestedAttributeValueNewsan?.id){
                        setShowPopup(true);
                        await fetchData({attributeValueNewsanId: r.relationsAttributesValues[0]?.suggestedAttributeValueNewsan.id}, r.relationsAttributesValues[0].id)
                      }
                    }}>Si</Button>
                    <Button className={classes['iaButton']} onClick={async () => {
                      if (r.relationsAttributesValues[0].suggestedAttributeValueNewsan?.id){
                        setShowPopup(true);
                        await deleteSuggestedAttributeValue({relationAttributeValueId: r.relationsAttributesValues[0].id})
                      }
                    }}>No</Button>
                  </div>
                </div>
                :<span className={classes.error}>Sin configurar</span>,
          }
          , actions,
        undefined, 
        classes['storesDataTable'])
      }))
      setIdsSuggesteds(iaAssistance);
    }
  }, [setDataShow, dataGrid, loading]);

  const fetchData = async ( body?: {attributeValueStoreId?: number, attributeValueNewsanId: number}, relationId?: number) => {
    try{
      setLoadingResponse(true)
      if (isEdit && newEditItem?.relationsAttributesValues[0]?.id || relationId){
        await client.patch(`/attribute-values/${relationId ?? newEditItem?.relationsAttributesValues[0].id}`, body)
        setNewEditItem(undefined)
      }else{
        const numberIdAttributeRelation = Number(idAttributeRelation)
        await client.post('/attribute-values/create-relation', {...body, idAttributeRelation: numberIdAttributeRelation})
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        setErrorResponse(error.response?.data.message);
      } else if (error instanceof Error) {
        setErrorResponse([error.message]);
      } else {
        setErrorResponse(['Hubo un error en la solicitud']);
      }
    } finally {
      setLoadingResponse(false);
      formatForm()
      setShowForm(false)
      reloadTable();
    } 
  }

  const deleteSuggestedAttributeValue = async ( body?: {relationAttributeValueId: number}) => {
      try{
        setLoadingResponse(true)
        await client.post('/attribute-values/removeSuggested', body)
        formatForm()
        setShowForm(false)
      } catch (error) {
        if (axios.isAxiosError(error)) {
          setErrorResponse(error.response?.data.message);
        } else if (error instanceof Error) {
          setErrorResponse([error.message]);
        } else {
          setErrorResponse(['Hubo un error en la solicitud']);
        }
      } finally {
        setLoadingResponse(false);
        reloadTable();
      } 
    }

    const handleMassiveSuggestions = async (isAccepted: boolean) => {
      try{
        setOpenIaModal(true)
        setLoadingResponse(true)
        await client.post(`/attribute-values/${isAccepted ? 'massive-accept-suggested' : 'massive-remove-suggested'}`, {relationAttributeValueIds: idsSuggested})
        formatForm()
        setShowForm(false)
      } catch (error) {
        if (axios.isAxiosError(error)) {
          setErrorResponse(error.response?.data.message);
        } else if (error instanceof Error) {
          setErrorResponse([error.message]);
        } else {
          setErrorResponse(['Hubo un error en la solicitud']);
        }
      } finally {
        setLoadingResponse(false);
        setOpenIaModal(false);
        reloadTable();
      } 
    }

    const suggestAttributesValues = async () => {
      try{
        setOpenIaModal(true)
        setLoadingResponse(true)
        await client.post(`/attribute-values/suggest-attributes-values/${idAttributeRelation}`)
        formatForm()
        setShowForm(false)
      } catch (error) {
        if (axios.isAxiosError(error)) {
          toast.error(error.response?.data.message);
        } else if (error instanceof Error) {
          toast.error(error.message);
        } else {
          toast.error('Hubo un error en la solicitud');
        }
      } finally {
        setLoadingResponse(false);
        setOpenIaModal(false)
        reloadTable();
      } 
    }

  const saveFormInfo = async () => {
    if (!selectedAttributeGEND && !selectedAttributeStore){
      alert('Se deben completar todos los campos')
    } else if (selectedAttributeGEND){
      const temporalObject: {attributeValueStoreId?: number, attributeValueNewsanId: number} = {
        attributeValueNewsanId: selectedAttributeGEND.id,
        attributeValueStoreId: isEdit && newEditItem?.relationsAttributesValues[0]?.id ? undefined : selectedAttributeStore?.id,
      }
      setShowPopup(true);
      await fetchData(temporalObject)
    }
  }

  
  const optionsGend = useMemo(() => {
    if (!dataOptionsGend) return [];
  
    const existingIds = new Set(dataOptionsGend.map((item) => item.id));
    const attributeValueNewsan = newEditItem?.relationsAttributesValues[0]?.attributeValueNewsan;

    if (!attributeValueNewsan) return dataOptionsGend;

    const additionalItem = {
      ...attributeValueNewsan,
      value: `${attributeValueNewsan.code} - ${attributeValueNewsan.value}`
    };

    if (isEdit && !existingIds.has(additionalItem.id)) {
      return [...dataOptionsGend, additionalItem];
    }
  
    return dataOptionsGend;
  }, [dataOptionsGend, newEditItem, isEdit]);
  
  useEffect(()=>{
    if(newEditItem){
      setSelectedAttributeGEND(optionsGend?.find(gendOption => gendOption.id.toString() == newEditItem.relationsAttributesValues[0]?.attributeValueNewsan?.id.toString()) || undefined);
      setSelectedAttributeStore(dataOptionsStore?.find(storeOption => storeOption.id.toString() == newEditItem?.id.toString()) || undefined);
    }
  }, [newEditItem]);
  
  useEffect(()=>{
    setEndpointOptionGend(`attribute-values/gendByRelationsAttribute/${idAttributeRelation}/autocomplete?omit-configured=${isEdit}`)
  }, [isEdit]);

  function formatForm(){
    setSelectedAttributeGEND(undefined)
    setSelectedAttributeStore(undefined)
    setIsEdit(false)
    setNewEditItem(undefined)
  }

  function reloadTable() {
    setBaseEndpoint('')
    setEndPoint('')
    setEndpointOptionGend('')
    setEndpointOptionStore('')
    setIdsSuggesteds([])
  }

  const onClose = () => {
      formatForm()
      setShowForm(false)
      setIsEdit(false)
      setNewEditItem(undefined)
  }

  const onCancel = () => {
      setShowForm(false)
      setIsEdit(false)
      setNewEditItem(undefined)
      setErrorResponse(null)
      formatForm()
  }

  return (
    <div className={classes.errorTransactionPage}>
      {
        loading  || loadingResponse || loadingOptionsGend || loadingOptionsStore ?
        <div className='loadingPage'>
          <CircularProgress className='circleProgress'/>
        </div>
        : null
      }
      <div className={classes.storesPage}>
      <Topbar title={`Valores Posibles - ${dataGrid?.attributeData?.description} - ${dataGrid?.attributeData?.categoryStore?.store?.description} `} backButton hasReloadIcon reloadPage={reloadTable} >
        {
        idsSuggested.length > 0 ? 
          <div className={classes['iaContent']} style={{
            justifyContent: 'flex-end'
          }}>
              <span className={classes['iaText']}>Recomendaciones IA</span>
              <div className={classes['iaButtonContent']}>
                <Button className={classes['iaButton']} onClick={async () => {
                  setShowPopup(true);
                  await handleMassiveSuggestions(true)
                }}>Si</Button>
                <Button className={classes['iaButton']} onClick={async () => {
                  setShowPopup(true);
                  await handleMassiveSuggestions(false)
                }}>No</Button>
              </div>
          </div>
          :
          <div className={classes['iaContent']} style={{
            justifyContent: 'flex-end'
          }}>
            <div className={classes['iaButtonContent']}>
              <Button className={classes['iaButton']} onClick={async () => {
                setShowPopup(true);
                await suggestAttributesValues()
              }}>Sugerir Sinonimia</Button>
            </div>
          </div>
          }
      </Topbar>
      <div className={  showForm ? classes['table-templates-container-form-visible'] : classes['table-templates-container']}>
          <DataTable
            headers={dataHeader}
            rows={dataShow}
            countItems={countItems}
            rowsPerPage={dataTo}
            hasActions={true}
            groupActions={false}
            appendOnScrollToBottom={false}
            onPageSizeChange={(size) => {setDataTo(size); setDataOffset(0); }}
            onPageChange={(page: number)=>{ setDataOffset(page-1) }}
            pageSelected={dataOffset+1}
            pageable={true}
            selectable={false}
            className={classes.storesDataTable}
          ></DataTable>
        </div>

        <CrudContainer 
          showForm={showForm}
          onShowForm={() => setShowForm(true)}
          onCancel={onCancel}
          isEdit={isEdit}
          onClose={onClose}
          onSave={saveFormInfo}
        >
          <span className={classes['setting-attr-title']}>Cod - Valor Tienda*</span>
            <FormControl className={classes['select-filter']} size='small'>
              <Select
                value={selectedAttributeStore ? dataOptionsStore?.find(storeOption => storeOption.id.toString() == selectedAttributeStore.id.toString())?.id : (newEditItem?.id.toString() ?? null)}
                onChange={(e) => setSelectedAttributeStore(dataOptionsStore?.find(storeOption => storeOption.id.toString() === e.target.value))}
                disabled={isEdit}
              >
                <MenuItem value={''}>
                  <em className={classes['no-selection']}>Seleccionar</em>
                </MenuItem>
                {dataOptionsStore?.map((e)=>(
                  <MenuItem className={classes['select-option']} key={e.id} value={e.id.toString()}>
                  {e.value}
                </MenuItem>
              ))}
              </Select>
            </FormControl>
            <span className={classes['setting-attr-title']}>Cod - Valor GenD*</span>
            <FormControl className={classes['select-filter']} size='small'>
              <Select
                value={selectedAttributeGEND ? optionsGend?.find(gendOption => gendOption.id.toString() == selectedAttributeGEND.id.toString())?.id : (newEditItem?.relationsAttributesValues[0]?.attributeValueNewsan?.id.toString() ?? null)}
                onChange={(e) => setSelectedAttributeGEND(optionsGend?.find(gendOption => gendOption.id.toString() === e.target.value))}
              >
                <MenuItem value={''}>
                  <em className={classes['no-selection']}>Seleccionar</em>
                </MenuItem>
                {optionsGend?.map((e)=>(
                  <MenuItem className={classes['select-option']} key={e.id} value={e.id.toString()}>
                  {e.value}
                </MenuItem>
              ))}
              </Select>
            </FormControl>
        </CrudContainer> 
      </div>

      <ConfirmDialog
        open={openConfirmDialog}
        onClose={() => setOpenConfirmDialog(false)}
        onConfirm={confirmDelete}
        title="Confirmar eliminación"
        message="¿Está seguro de que desea eliminar esta configuración?"
      />

      <Modal
        open={openIaModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        onClose={(event, reason) => {
          if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
            handleCloseIaModal();
          }
        }}
      >
        <Box sx={{position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          borderRadius: 4,
          boxShadow: 24,
          border: '2px solid var(--primary-color)',
          p: 3,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '2vw'
        }}>
          <Typography>Se está ejecutando el asistente de sinonimia, este proceso puede demorar varios segundos. Gracias por la espera.</Typography>
            <CircularProgress />
        </Box>
      </Modal>
    </div>
  )
}

export default AttributesValues;
